import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

import SrIcon from 'client/components/SrIcon';
import SrFlex from 'client/components/SrFlex';

import './SrPayrollCard.less';

const SrPayrollCard = ({ incomeVerificationId, reportData, onClick }) => {
  return (
    <SrBox styleName={classNames('optionContainer')}>
      <SrFlex align="center">
        <SrBox styleName={classNames('iconContainer')}>
          <SrIcon className="payroll-icon-active" />
        </SrBox>
        <SrBox>
          <SrText weight="bold" color="green" size="16" display="block">
            Payroll provider linked
          </SrText>
          <SrText weight="500" size="13" lineHeight="18.45px">
            For employees with direct deposit
          </SrText>
        </SrBox>
        <div styleName={classNames('checkboxIcon')}>
          <SrIcon className="checkmark-white" />
        </div>
      </SrFlex>
      <SrBox margin="32px 0 2px 0">
        <SrText weight="500" size="16" lineHeight="24px">
          Report ID: {incomeVerificationId}
        </SrText>
        <hr styleName={classNames('divider')} />
        <SrFlex width="100%">
          <SrFlex wrap="wrap" width="100%">
            {reportData.map((item) => (
              <SrBox key={item.label} styleName={classNames('item')}>
                <SrText weight="800" size="14" lineHeight="16px" display="block">
                  {item.label}
                </SrText>
                <SrText weight="500" size="16" lineHeight="24px">
                  {item.value}
                </SrText>
              </SrBox>
            ))}
          </SrFlex>
          <SrBox />
        </SrFlex>
      </SrBox>
      <SrText weight="500" size="14" lineHeight="20px" width="100%" display="block">
        You can still use the other options to provide more verification if applicable.
      </SrText>
      <SrBox marginTop="28px" />
      <SrText
        onClick={onClick}
        size="16"
        decoration="underline"
        cursor="pointer"
        color="blue300"
        weight="600"
        lineHeight="24px"
      >
        Re-sync payroll provider
      </SrText>
      <SrBox marginTop="16px" />
    </SrBox>
  );
};

SrPayrollCard.propTypes = {
  onClick: PropTypes.func,
  reportData: PropTypes.array,
  incomeVerificationId: PropTypes.number,
};

export default SrPayrollCard;
